import type { NumericPricing, LocalizedPricing } from './pricingTypes';
import type { Locale } from 'common/types';
import { formatPrice } from 'utils/currencyUtils';

// TODO: Use the `Money` type instead of this
function maybeFormattedPrice(
  locale: Locale,
  p: number | null | undefined
): string | null | undefined {
  // If the price is 0 or null, render nothing
  if (!p) {
    return null;
  }
  // If the price is a round number, leave the decimals out
  if (Number.isInteger(p)) {
    return formatPrice(p, { precision: 0, locale: locale });
  }
  // Otherwise render with locale specific precision
  return formatPrice(p, { locale: locale });
}

export function toLocalizedPrices(p: NumericPricing): LocalizedPricing {
  const { locale } = p;
  return {
    additionalRentPerHour: maybeFormattedPrice(locale, p.additionalRentPerHour),
    cleaningFee: maybeFormattedPrice(locale, p.cleaningFee),
    genericFixed: maybeFormattedPrice(locale, p.genericFixed),
    perPerson: maybeFormattedPrice(locale, p.perPerson),
    rentFixed: maybeFormattedPrice(locale, p.rentFixed),
    rentPerHour: maybeFormattedPrice(locale, p.rentPerHour),
    salesGuarantee: maybeFormattedPrice(locale, p.salesGuarantee),
    salesGuaranteePerHour: maybeFormattedPrice(locale, p.salesGuaranteePerHour)
  };
}
